import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  inject,
  provideAppInitializer,
  provideNgReflectAttributes,
} from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  IntrackCoreModule,
  ConfigService,
  IntrackFeatureModule,
  DashboardLayoutModule,
  loadConfiguration,
  loadLanguages,
  APP_VERSION,
  AnnouncementState,
  AppState,
  LoadingState,
  AuthState,
  ListSearchCriteriaState,
  CatalogSearchCriteriaState,
  HubContextState,
  SvgIconState,
  ReasonCodeState,
  StatusCodeState,
  FilterOptionsState,
  DatepickerModelRequestConverterInterceptor,
  APPLICATION_TYPE_TOKEN,
  ApplicationTypeToken,
  AuthCookieInterceptor,
  BrainWebchatModule,
} from '@intrack/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DashboardComponent } from './dashboard/dashboard.component';
import { WelcomePageComponent } from './welcome-page/welcome-page.component';
import { NgxsModule } from '@ngxs/store';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';
import { environment } from '../environments/environment';
import { MAT_SELECT_CONFIG } from '@angular/material/select';

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json?v=' + APP_VERSION);
}

@NgModule({
  declarations: [AppComponent, DashboardComponent, WelcomePageComponent],
  imports: [
    AppRoutingModule,
    IntrackCoreModule,
    IntrackFeatureModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: false,
    }),
    NgxsModule.forRoot(
      [
        AppState,
        LoadingState,
        AuthState,
        ListSearchCriteriaState,
        CatalogSearchCriteriaState,
        AnnouncementState,
        HubContextState,
        SvgIconState,
        ReasonCodeState,
        StatusCodeState,
        FilterOptionsState,
      ],
      {
        developmentMode: !environment.production,
      },
    ),
    NgxsReduxDevtoolsPluginModule.forRoot(),
    NgxsRouterPluginModule.forRoot(),
    DashboardLayoutModule,
    BrainWebchatModule,
  ],
  providers: [
    ConfigService,
    { provide: APPLICATION_TYPE_TOKEN, useValue: ApplicationTypeToken.IntrackApp },
    provideAppInitializer(() => {
      const initializerFn = loadConfiguration(inject(ConfigService), inject(APPLICATION_TYPE_TOKEN));
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = loadLanguages(inject(ConfigService));
      return initializerFn();
    }),
    { provide: HTTP_INTERCEPTORS, useClass: AuthCookieInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DatepickerModelRequestConverterInterceptor, multi: true },
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { overlayPanelClass: 'mat-mdc-select-overlay-panel' },
    },
    // Enable ng-reflect-* debug attributes in the DOM
    ...(!environment.production ? [provideNgReflectAttributes()] : []),
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
